import React, { useEffect, useState } from 'react';
import { Grid, TextField, Button } from '@mui/material';
import dialogStyles from '../../../../components/dialog/GenericDialog.styles';
import ValidatedField from '../../../../components/inputs/ValidatedField';
import { updateOperatorName } from '../../services/operator.api';
import { OPERATOR_NAME_RULES } from '../../utils/operatorValidation';

export default function ModifyOperatorTab({ initialData, onSubmit, helpers }) {
  const { close, setLoading } = helpers;

  const [newName, setNewName] = useState('');
  const nameChanged = newName.trim() !== '';
  const validName = OPERATOR_NAME_RULES.every((r) => r.test(newName));
  const canSave = validName && nameChanged;

  useEffect(() => {
    setNewName('');
    setLoading(false);
  }, [setLoading, initialData?.code]);

  const handleSave = async () => {
    if (!canSave) return;
    const updatedName = nameChanged ? newName.trim() : initialData.name;
    setLoading(true);
    try {
      await updateOperatorName(initialData.code, updatedName);
      onSubmit?.();
      close();
      window.location.reload();
    } catch (err) {
      console.error('API error:', err);
      alert('Could not save changes');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            label="Operator Code"
            fullWidth
            size="small"
            variant="standard"
            value={initialData.code}
            InputProps={{ readOnly: true, disableUnderline: true }}
            sx={dialogStyles.readonlyField}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Current Name"
            fullWidth
            size="small"
            variant="standard"
            value={initialData.name}
            InputProps={{ readOnly: true, disableUnderline: true }}
            sx={dialogStyles.readonlyField}
          />
        </Grid>
        <Grid item xs={12}>
          <ValidatedField
            label="New Name"
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            placeholder={initialData.name}
            rules={OPERATOR_NAME_RULES}
          />
        </Grid>
      </Grid>

      <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 16 }}>
        <Button onClick={close} variant="contained" sx={dialogStyles.btnSecondary}>
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          disabled={!canSave}
          variant="contained"
          sx={dialogStyles.btnPrimary}
        >
          Save Changes
        </Button>
      </div>
    </>
  );
}
